import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.FilteredTagsPieChartView extends Monitoring.Views.Charts.PieChartView

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.filtered_tags')
    @title_en = I18n.t('monitoring.dashboard.charts.filtered_tags', {'locale': 'en'})
    super(@options)
    @tagsByClientCode = @options.tagsByClientCode
    filtered_tags = _.flatten(_.map(['', 'primary_', 'secondary_'], (prefix) => @searchQuery.get(prefix + 'tags')))
    @facets.tag.terms = _.filter(@facets.tag.terms, (term) => term.term in filtered_tags)
    @name = 'tag'

  getPieData: (name) ->
    count = _.reduce(@facets[name]['terms'] || [], (acum, tag) ->
      acum + tag["count"]
    , 0)

    return _.collect(@facets[name]['terms'], (facet) =>
      name = @tagsByClientCode[facet.term] || facet.term
      percentage = ((facet.count*100)/count).toFixed(2) if count > 0
      { tag: facet.term, name: name, y: facet.count, code: name, percentage: percentage}
    )

  getNewQuery: (event) ->
    query = @searchQuery.deepCopy()
    tag = _.invert(@tagsByClientCode)[event.point.tag] || event.point.tag
    key = if _.isEmpty(query.get('primary_tags')) then 'primary_tags' else 'secondary_tags'
    query.set(key, [tag])
    return query

  _getChartOptions: ->
    chartOptions = {}
    if @_settings.maximized
      chartOptions =
        legend:
          enabled: true
          labelFormat: "{name} ({percentage:.2f}%)"
      $.extend(true, chartOptions, @customChartOptions()) if @customChartOptions()
    else
      chartOptions = @customChartOptions() if @customChartOptions()
    return chartOptions

  _getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('dimension', 'tags')
    if @shiftedDays
      new Monitoring.Views.Charts.QueryDateShifter(query).shiftXDaysBack(@shiftedDays)
    else
      query

  _doBencharmark: (benchmark) ->
    query = @_getSearchQuery()
    if !@$el.hasClass('w2')
      @$el.addClass('w2')
    @afterAppend()
    query.set('benchmark', {
      date_from_ISO: query.get('date_from_ISO')
      date_to_ISO: query.get('date_to_ISO')
    })

    @ajaxCall(@url, query.toJSON(), (response) =>
      filtered_tags = _.flatten(_.map(['', 'primary_', 'secondary_'], (prefix) => @searchQuery.get(prefix + 'tags')))
      response_series = _.map(response.series, (serie) => {data: _.filter(serie.data, (point) -> point.code in filtered_tags)})
      response.series = response_series
      response_benchmark_data = _.map(response.benchmark_data, (benchmark) => {data: _.filter(benchmark.data, (point) -> point.code in filtered_tags)})
      response.benchmark_data = response_benchmark_data
      @dataBenchmark = response
      @current = I18n.t('monitoring.dashboard.charts.titles.'+benchmark)
      benchmark = 'Benchmark'
      @$el.html(@templateWithBenchmark({
        title: @title,
        current: @current,
        benchmark: benchmark
      }))
      @$el.find('#benchmark-action').html(@benchmarkaActionTemplate( {hasOneBenchmark: true } ))
      @removeActiveBenchmarkAction()
      @chart = new Highcharts.Chart($.extend(true, @_getOptions(), @_getChartOptions()))
      @benchmarkChart = new Highcharts.Chart(@benchmarkChartOptions(@current))
    )
